import * as React from "react";

import Layout from "../../components/Layout";
import BlogRoll from "../../components/BlogRoll";

export default class BlogIndexPage extends React.Component {
  render() {
    return (
      <Layout>
        <h3
            className="has-text-weight-bold is-size-3 has-text-centered"
            style={{
              color: "black",
              padding: "1rem",
            }}
          >
            Κείμενα
        </h3>
        <section className="section">
          <div className="container">
            <div className="content">
              <BlogRoll />
            </div>
          </div>
        </section>
      </Layout>
    );
  }
}
